import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
/**
 * React hook which returns whether the component was mounted during previous render
 * Useful for e.g. animations that need to check whether this is the initial render.
 */

var usePrevMounted = function usePrevMounted() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mounted = _React$useState2[0],
      setMounted = _React$useState2[1];

  var mountedTimer = React.useRef();
  React.useEffect(function () {
    mountedTimer.current = window.setTimeout(function () {
      return setMounted(true);
    }, 0);
    return function () {
      return clearTimeout(mountedTimer.current);
    };
  }, []);
  return [mounted, setMounted];
};

export { usePrevMounted };